<template>
  <v-card>
    <v-container fluid>
      <v-row dense align="center">
        <v-col>
          <v-row dense>
            <v-col>
              Executado em
              {{ executedAt | moment("DD/MM/YYYY hh:mm") }}
            </v-col>
          </v-row>
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <authorization permissionKey="attendance_exam" can="print" v-slot:default="{ authorization }">

<template>
  <div class="text-center" cols="auto" v-if="authorization || forcePrint">
    <!-- Menu principal -->
    <v-menu open-on-click left offset-x close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon :loading="printLoading" v-bind="attrs" v-on="on">
          <v-icon>eva-printer-outline</v-icon>
          <v-icon>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <!-- Submenu para DOWNLOAD -->
        <v-menu open-on-hover left offset-x close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item link v-bind="attrs" v-on="on">
              <v-list-item-title>Exame Completo</v-list-item-title>
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item>
          </template>
          <v-list>
            <v-list-item link>
              <v-list-item-title @click="downloadArchive(true, true)">Download PDF</v-list-item-title>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title @click="send(true, true)">Enviar por Email</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Submenu para DOWNLOAD -->
        <v-menu open-on-hover left offset-x close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item link v-bind="attrs" v-on="on">
              <v-list-item-title>Somente Laudo</v-list-item-title>
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item>
          </template>
          <v-list>
            <v-list-item link>
              <v-list-item-title @click="downloadArchive(false, true)">Download PDF</v-list-item-title>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title @click="send(false, true)">Enviar por Email</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Submenu para DOWNLOAD -->
        <v-menu open-on-hover left offset-x close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item link v-bind="attrs" v-on="on">
              <v-list-item-title>Somente Exame</v-list-item-title>
              <v-icon>mdi-menu-right</v-icon>
            </v-list-item>
          </template>
          <v-list>
            <v-list-item link>
              <v-list-item-title @click="downloadArchive(true, false)">Download PDF</v-list-item-title>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title @click="send(true, false)">Enviar por Email</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list>
    </v-menu>
  </div>
</template>



    </authorization>
          <authorization
            v-if="allowEdit" permissionKey="attendance_exam" can="save" v-slot:default="{ authorization }" >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small icon :attrs="attrs" v-on="on" :to="`exames/${exam.id}`" v-if="authorization" :disabled="signed" >
                  <v-icon>eva-edit-outline</v-icon>
                </v-btn>
              </template>

              <span> Editar </span>
            </v-tooltip>
          </authorization>

          <authorization v-if="allowDelete" permissionKey="attendance_exam" can="delete" v-slot:default="{ authorization }" >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small icon :attrs="attrs" v-on="on" @click="deleteExam" v-if="authorization" :disabled="signed || attendanceEsigned" >
                  <v-icon>eva-trash-outline</v-icon>
                </v-btn>
              </template>

              <span> Excluir </span>
            </v-tooltip>
          </authorization>

          <v-btn icon small @click="showContent = !showContent">
            <v-icon v-if="showContent">eva-chevron-up-outline</v-icon>
            <v-icon v-else>eva-chevron-down-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-show="showContent">
        <ExamForm :attendance="attendance" :exam="exam" disabled />
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import ExamForm from "@/components/exam/form.vue";

export default {
  name: "ExamListItem",
  props: {
    attendance: Object,
    exam: Object,
    index: Number,
    attendanceEsigned: Boolean,
    refreshList: Function,
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
    forcePrint: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ExamForm,
  },
  data() {
    return {
      showContent: false,
      printLoading: false,
    };
  },
  computed: {
    examTemplateName() {
      if (this.exam?.examTemplate?.name) {
        return this.exam.examTemplate.name;
      }

      return "Exame";
    },

    executedAt() {
      if (this.exam?.executedAt) {
        return this.$moment(this.exam.executedAt, "YYYY-MM-DD HH:mm:ss ZZ");
      }

      return null;
    },

    signed() {
      if (this.exam) {
        return this.exam.lastEsign.status !== "editable";
      }

      return false;
    },
  },

  methods: {
    deleteExam() {
      if (confirm("Você realmente deseja deletar esse exame?")) {
        this.apolloMutate({
          mutation: require("@/graphql/exam/delete_exam.gql"),
          variables: {
            examId: this.exam.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Exame deletado com sucesso.",
            type: "success",
          });
        });
      }
    },

    async sendEmail(dynamicForm, examAppraisal) {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/send_email.gql"),
        variables: {
          esignId: this.exam.lastEsign.id,
          patientId: this.attendance.patient.id,
          dynamicForm: dynamicForm,
          examAppraisal: examAppraisal
        },
      });
    },

    async send(dynamicForm, examAppraisal) {
      this.printLoading = true;

      try {
        await this.sendEmail(dynamicForm, examAppraisal);

        this.$store.dispatch("createNotification", {
        message: "email enviado.",
        type: "success",
        });
      } catch (error) {
        console.error("Erro ao enviar email ou atualizar a lista:", error);

        this.$store.dispatch("createNotification", {
        message: "Falha ao enviar email ou atualizar a lista.",
        type: "error",
        });
      } finally {
        this.printLoading = false;
      }
    },

    async generatePreview(dynamicForm, examAppraisal) {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.exam.lastEsign.id,
          dynamicForm: dynamicForm,
          examAppraisal: examAppraisal
        },
      });
    },

    async downloadArchive(dynamicForm, examAppraisal) {
      this.printLoading = true;
      await this.generatePreview(dynamicForm, examAppraisal);
      await this.refreshList();
      //await this.$store.dispatch("authentication/refreshToken");

      //if (this.exam.lastEsign.status === "signed") {
      const file_url = this.exam.lastEsign.fileUrl;

      await window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");
      // } else {
      //   this.$store.dispatch("createNotification", {
      //     message: "É necessário assinar antes de imprimir.",
      //     type: "error",
      //   });
      // }

      this.printLoading = false;
    },

  },
};
</script>

<style lang="scss" scoped></style>
